import { Radio, RadioProps, styled } from "@mui/material";


const RadioIcon = styled('span')(() => ({
    borderRadius: '50%',
    width: 16,
    height: 16,
    border: '2px solid #7E86A0',
}));
  
const RadioCheckedIcon = styled(RadioIcon)({
    backgroundColor: '#546FFF',
    '&::before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
      content: '""',
    },
    border: "none"
});
  
const ThemedRadio = (props: RadioProps) => {
    return (
      <Radio
        disableRipple
        color="default"
        checkedIcon={<RadioCheckedIcon />}
        icon={<RadioIcon />}
        {...props}
      />
    );
} 

export default ThemedRadio;